import * as React from "react";
const SvgQuestionSmall = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M14.469 10.313c-.021.062-.094.229-.219.5-.02.02-.156.187-.406.5a5.865 5.865 0 0 1-.625.53c-.146.105-.26.23-.344.376a.832.832 0 0 0-.094.375v.312h-1.594v-.469c0-.208.032-.395.094-.562.084-.167.177-.302.281-.406.126-.125.313-.292.563-.5l.406-.406c.042-.042.094-.105.156-.188l.157-.156a.762.762 0 0 0-.125-.906.834.834 0 0 0-.563-.188c-.354 0-.604.094-.75.281-.166.167-.27.386-.312.656L9.469 9.97c.062-.771.333-1.344.812-1.719.48-.396 1.094-.594 1.844-.594.375 0 .688.042.938.125.291.104.541.24.75.407.229.208.406.427.53.656.126.25.188.552.188.906 0 .167-.02.354-.062.563Zm-1.563 5.437a1.19 1.19 0 0 1-.219.313 1.19 1.19 0 0 1-.312.218 1.714 1.714 0 0 1-.375.063c-.104 0-.24-.021-.406-.063a4.029 4.029 0 0 1-.313-.218.628.628 0 0 1-.187-.313.832.832 0 0 1-.094-.375c0-.146.031-.281.094-.406a.56.56 0 0 1 .187-.281.659.659 0 0 1 .313-.22.896.896 0 0 1 .406-.093c.125 0 .25.031.375.094.125.02.23.094.313.219.041.02.114.114.218.28.042.167.063.303.063.407 0 .083-.021.208-.063.375ZM12 4c-2.208 0-4.094.781-5.656 2.344C4.78 7.906 4 9.792 4 12c0 2.208.781 4.094 2.344 5.656C7.906 19.22 9.792 20 12 20c2.208 0 4.094-.781 5.656-2.344C19.22 16.094 20 14.208 20 12c0-2.208-.781-4.094-2.344-5.656C16.094 4.78 14.208 4 12 4Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgQuestionSmall;
